var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-2"},[_c('div',{staticClass:"v1"},[_vm._v("提供各类免费手游辅助")]),_c('div',{staticClass:"v2"},[_vm._v("部落冲突 / 天龙八部 / 新剑侠情缘 / 热血传奇")]),_c('div',{staticClass:"v3"},[_c('img',{attrs:{"src":require("@/assets/img/i_27.png")}})])])
}]

export { render, staticRenderFns }